export enum IdentityProvider {
  IdentityServer4 = 'IdentityServer4',
  Okta = 'Okta',
}

export interface IdentityClaims {
  customer_id?: string;
  sub?: string;
  iss?: string;
}

export interface GetIdentityProviderResponse {
  status: number;
  isSuccess: boolean;
  data: IdentityProvider;
}
